import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const SwitchFilterSimGolf = ({
  switchFor,
  isChecked,
  setIsChecked,
  toggleGolfHubPublished,
  id,
  selectedDropdownOption,
  openPopup,
  popupTypes,
  openRegistrationData,
  onChange,
  checkedSuffix,
  uncheckedSuffix,
}) => {
  useEffect(() => {
    if (openRegistrationData)
      setIsChecked(
        openRegistrationData.openRegistrationStatus === 'open' ||
        openRegistrationData.openRegistrationStatus === 'invitation_list'
      )
  }, [openRegistrationData])

  const handleOnClick = (switchFor) => {
    if (switchFor === 'category') {
      setIsChecked(!isChecked)
      if (isChecked) {
        onChange('viewType', 'list')
      } else {
        onChange('viewType', 'category')
      }
    } else if (switchFor === 'golfHub') {
      toggleGolfHubPublished(id, isChecked, `/leagues/${id}/publish_to_directory`)
      setIsChecked(!isChecked)
    } else if (switchFor === 'openRegistration') {
      openPopup(popupTypes, { selectedDropdownOption })
    }
  }

  return (
    <span className='switch_button_category_container'>
      <label className='switch_button_category' id='switch_button'>
        <input type='checkbox' checked={ isChecked } onChange={ () => handleOnClick(switchFor) }/>
        <span className='switch_button_category_slider round'></span>
      </label>
      <span className='switch_label'>
        <span className='invisible'>{ isChecked ? uncheckedSuffix : checkedSuffix }</span>
        <span>{ isChecked ? checkedSuffix : uncheckedSuffix }</span>
      </span>
    </span>
  );
}

SwitchFilterSimGolf.propTypes = {
  switchFor: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  setIsChecked: PropTypes.func,
  onChange: PropTypes.func,
  toggleGolfHubPublished: PropTypes.func,
  id: PropTypes.string,
  selectedDropdownOption: PropTypes.object,
  openPopup: PropTypes.func,
  popupTypes: PropTypes.string,
  openRegistrationData: PropTypes.object,
  checkedSuffix: PropTypes.string.isRequired,
  uncheckedSuffix: PropTypes.string,
}

export default SwitchFilterSimGolf